export type AccessControlActions = "create" | "delete" | "read" | "update";

/** Role-based permissions for resources */
export type IRolePermission = {
  [action in AccessControlActions]?: boolean;
};
export interface IRolePermissions {
  [resource: string]: IRolePermission;
}

export function mergePermissions(
  userPermissions: IRolePermissions | string,
  companyPermissions: IRolePermissions | string
): IRolePermissions {
  // Parse permissions if they are JSON stringified
  const user = safeJSONparse<IRolePermissions>(userPermissions) || {};
  const company = safeJSONparse<IRolePermissions>(companyPermissions) || {};

  const mergedPermissions: IRolePermissions = {};
  
  const allKeys = new Set([
    ...Object.keys(user),
    ...Object.keys(company),
  ]);

  allKeys.forEach((key) => {
    const userOps = user[key] || {};
    const companyOps = company[key] || {};
    const allOps = new Set<AccessControlActions>([
      ...Object.keys(userOps) as AccessControlActions[],
      ...Object.keys(companyOps) as AccessControlActions[],
    ]);

    mergedPermissions[key] = {};

    allOps.forEach((op) => {
      if (key in user && key in company) {
        mergedPermissions[key][op] = Boolean(
          userOps[op] && companyOps[op]
        );
      } else {
        mergedPermissions[key][op] = Boolean(
          userOps[op] || companyOps[op]
        );
      }
    });
  });

  return mergedPermissions;
}

export function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e: any) {
    return false;
  }
  return true;
}

export function safeJSONparse<T>(data: any) {
  if (data === 'undefined') return undefined;
  if (data === 'null') return null;

  return (isJsonString(data) ? JSON.parse(data) : data) as T;
}
